import React, {Fragment} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Box} from "@mui/material";
import { frontAppOauthActions } from "_actions";
import {buttonContained} from "../../Utilities/ButtonContained";
import BasicModal from "../../../../common/BasicModal";
import {basicModalStyle} from "../../Utilities/basicModalStyles";
import Checkbox from "../../Utilities/Checkbox";

export default function FrontappSetupInboxesModal({open, handleClose}) {
  const dispatch = useDispatch()
  const {SolidButton} = buttonContained;
  const frontApp = useSelector((state) => state.frontAppOauth)
  const [inboxList, setInboxList] = React.useState([]);
  const [messageDataSourceId, setMessageDataSourceId] = React.useState('');

  React.useEffect(() => {
    if (frontApp.showInboxes && frontApp.inboxList?.length > 0) {
      setInboxList(frontApp.inboxList);
      setMessageDataSourceId(frontApp.messageDataSourceId);
    }
  }, [frontApp])

  const handleItemSelection = (itemIndex, newVal) => {
    setInboxList(inboxList.map((item, index) => {
      if (itemIndex === index) 
        item.checked = newVal
      return item
    }))
  }

  const handleSaveInboxes = (event) => {
    event.preventDefault()
    const formData = {
      messageDataSourceId,
      inboxes: inboxList.filter(item => item.checked),
    }
    dispatch(frontAppOauthActions.createInboxes(formData));
  }

	return (
		<Fragment>
          <BasicModal
            open={open}
            handleClose={handleClose}
            title={'Select Frontapp Inboxes to connect with Chatdesk'}
            style={basicModalStyle}
          >
            {inboxList?.length > 0
              ? inboxList.map((inbox, key) => (
                <Box key={key} sx={styles.item}>
                  <Checkbox
                    id={inbox.id}
                    name="selected"
                    label={inbox.name}
                    checked={!!inbox.checked}
                    onChange={newVal => handleItemSelection(key, newVal)}
                  />
                </Box>
              ))
              : <div>No inboxes found</div>}

            <Box sx={styles.buttonContainer}>
              <SolidButton label="Connect" action={handleSaveInboxes} />
            </Box>
          </BasicModal>
        </Fragment>
	)
}
const styles = {
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: 1.5,
    color: '#0C2728',
    fontFamily: 'larsseitRegular',
    fontSize: '16px',
    lineHeight: '120%',
    letterSpacing: '-0.02em',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 2.5,
    width: '100%'
  }
}
